






























import Vue from "vue";

export default Vue.extend({
  props: {
    banner: Array,
    news: Array,
  },
  methods: {
    ga(id) {
      (this as any).$ga.event("banner", "click", id, 1);
    },
  },
});
